<div class="container">

    <div style="width: 100%">
      <h1 style="width: 100%; text-align: center; font-weight: bold;">Autorizar Excepción</h1>
        <label for="swal-comment" style="font-weight: bold;">Comentario:</label>
        <textarea id="swal-comment" class="form-control" rows="3" placeholder="Ingrese un comentario" [(ngModel)]="Comment"></textarea>
    </div>
    <div class="card">
      <h3>Cargar Documento</h3>
      <div class="drop_box" [class.dragover]="isDragOver" >
        <header>
          <h4>Seleccionar Documento</h4>
        </header>
        <p>Selecciona o arrastra el documento que deseas cargar</p>
        <input type="file" #fileInput (change)="onFileSelected($event)" hidden
        accept=".pdf, .doc, .docx, .xls, .xlsx, .csv, image/*"
        id="fileID">
        <button class="btn" (click)="fileInput.click(); $event.stopPropagation()" >Elegir Documento</button>
        <form *ngIf="fileName" action="" method="post" style="width: 100%; display: flex;flex-direction: column; justify-content: center; align-items: center; margin-top: 20px;">
          <div class="form" style="width: 100%; display: flex;flex-direction: column; justify-content: center; align-items: center;">
            <h4>{{ fileName }}</h4>
          </div>
        </form>
      </div>
      <div></div>
    </div>

    <div style="width: 60%; display: flex; justify-content: center; align-items: center; gap: 20px;">
        <button 
        style="width: 60%; height: 50px; background-color: #1D589D; border-radius: 15px;
        color: white; border: none; cursor: pointer; position: relative; z-index: 20;"
        [disabled]="isLoading"
        (click)="sendFile()">
        
        <ng-container *ngIf="!isLoading">Autorizar</ng-container>
        <ng-container *ngIf="isLoading">
          <section class="dots-container" style="display: flex; justify-content: center; align-items: center; gap: 3px;">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </section>
        </ng-container>
      </button>


      <button style="width: 40%; height: 50px; background-color: rgb(164, 164, 164); border-radius: 15px;
      color: white; border: none; cursor: pointer; position: relative; z-index: 20;" (click)="dialog.close()" *ngIf="!isLoading">Cancelar</button>
    </div>
  </div>